import { PetTypeEnum, getEnumTranslationByKey } from '@/shared/enums';
import { IConsultationDto } from '@/shared/interfaces';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import {
    getAgeInYearsAndMonths,
    useNavigation,
} from '@/caregiverSpace/shared/lib';
import {
    PropertyObjectType,
    PropertyType,
} from '@/caregiverSpace/shared/model';
import { GoToPageButton, PropertiesList } from '@/caregiverSpace/shared/ui';

type VetPatientSectionProps = {
    consultation: IConsultationDto;
};

export const VetPatientSection = ({ consultation }: VetPatientSectionProps) => {
    const { goToPetPage, goToPetConsultation } = useNavigation();

    const properties: PropertyObjectType[] = [
        {
            label: R.Name,
            value: (
                <GoToPageButton
                    onClick={() =>
                        consultation.UID
                            ? goToPetConsultation(
                                  Number(consultation.OnBehalfOfPet.Id),
                                  consultation.UID,
                              )
                            : goToPetPage(Number(consultation.OnBehalfOfPet.Id))
                    }
                >
                    {consultation.OnBehalfOfPet.Name}
                </GoToPageButton>
            ),
            type: PropertyType.TEXT,
            className: 'grid grid-cols-[1fr_1fr]',
        },

        {
            label: R.PetType,
            value: getEnumTranslationByKey(
                PetTypeEnum,
                consultation.OnBehalfOfPet.Type,
            ),
            type: PropertyType.TEXT,
            className: 'grid grid-cols-[1fr_1fr]',
        },
    ];
    if (consultation.OnBehalfOfPet.Race) {
        properties.push({
            label: R.Race,
            value: consultation.OnBehalfOfPet.Race,
            type: PropertyType.TEXT,
            className: 'grid grid-cols-[1fr_1fr]',
        });
    }
    properties.push({
        label: R.Age,
        value: getAgeInYearsAndMonths(
            consultation.OnBehalfOfPet.Birthdate.toString(),
        ),
        type: PropertyType.TEXT,
        className: 'grid grid-cols-[1fr_1fr]',
    });

    return <PropertiesList properties={properties} />;
};
